import {
  WelcomeScreen,
  TextResponseScreen,
  VideoResponseScreen,
  ClosingScreen,
  CustomerFormScreen,
} from "../components/screens";
import { ScreenId } from "../types";
import { CollectionForm } from "./schema";

export const getTestimonialCollectionStepConfig = (
  data: CollectionForm,
  onStepChange: (ScreenId: ScreenId) => void,
): Record<ScreenId, JSX.Element> => {
  return {
    welcome: <WelcomeScreen data={data} onChangeStep={onStepChange} />,
    textResponse: (
      <TextResponseScreen data={data} onChangeStep={onStepChange} />
    ),
    videoResponse: (
      <VideoResponseScreen data={data} onChangeStep={onStepChange} />
    ),
    thankYou: <ClosingScreen data={data} onChangeStep={onStepChange} />,
    customerForm: (
      <CustomerFormScreen data={data} onChangeStep={onStepChange} />
    ),
  };
};
